import { IPagination } from "src/app/shared/models/page.model";
import { ISegment, SegmentFilterState } from "../models/segment.model";
import { createReducer, on } from "@ngrx/store";
import * as segmentsActions from './segments.actions';
import { refillSegmentFilter } from "src/app/shared/utils/helpers";

export interface SegmentsState {
    allSegments: ISegment[];
    metadata: IPagination | null;
    segments: ISegment[];
    loading: boolean;
    searchLoading: boolean;
    segmentFilterState: SegmentFilterState;
};

export const initialState: SegmentsState = {
    allSegments: [],
    metadata: null,
    segments: [],
    loading: false,
    searchLoading: false,
    segmentFilterState: {
        advanced: refillSegmentFilter(),
        keyword: ''
    }

};

const featureReducer = createReducer(
    initialState,
    on(
        segmentsActions.FetchAllSegmentsSuccess,
        (state, action) => ({
            ...state,
            allSegments: action.allSegments,
        })
    ),
    on(
        segmentsActions.FetchSegmentsSuccess,
        (state, action) => ({
            ...state,
            segments: action.segments.data,
            metadata: action.segments.metadata
        })
    ),
    on(segmentsActions.SetSegmentsLoader, (state, action) => ({
        ...state,
        loading: action.isLoading
    })),
    on(segmentsActions.SetSegmentFilter, (state, action) => ({
        ...state,
        segmentFilterState: {
            advanced: action.advanced!,
            keyword: action.keyword,
        }
    })),
    on(segmentsActions.SetSegmentSearch, (state, action) => ({
        ...state,
        segmentFilterState: {
            ...state.segmentFilterState,
            searchSegment: action.search,
        }
    }))
);

export function segmentsReducer(state: SegmentsState | undefined, action: any) {
    return featureReducer(state, action);
};